(function () {
  function money(cents, currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100); }
    catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  }

  function updateBundle(root) {
    var selected = root.querySelector('input[name="pn_bundle"]:checked');
    if (!selected) return;
    var data = JSON.parse(selected.getAttribute('data-bundle') || '{}');
    var variant = root.querySelector('[data-pn-variant]');
    var variantId = variant ? variant.value : data.variant_id;
    var price = Number(data.price || 0);
    var compare = Number(data.compare || 0);
    var quantity = Number(data.quantity || 1);
    if (variant && variant.selectedOptions[0]) {
      price = Number(variant.selectedOptions[0].getAttribute('data-price') || price) * quantity;
      compare = Number(variant.selectedOptions[0].getAttribute('data-compare') || compare) * quantity;
    }
    var idInput = root.querySelector('[data-pn-primary-id]');
    var quantityInput = root.querySelector('[data-pn-primary-quantity]');
    if (idInput) idInput.value = variantId;
    if (quantityInput) quantityInput.value = quantity;
    root.querySelectorAll('[data-pn-bundle-price]').forEach(function (el) { el.textContent = money(price, root.dataset.currency); });
    root.querySelectorAll('[data-pn-bundle-compare]').forEach(function (el) { el.textContent = compare > price ? money(compare, root.dataset.currency) : ''; });
    var giftId = root.querySelector('[data-pn-gift-id]');
    var giftQty = root.querySelector('[data-pn-gift-quantity]');
    if (giftId) giftId.disabled = !data.gift_id;
    if (giftQty) giftQty.disabled = !data.gift_id;
    if (giftId) giftId.value = data.gift_id || '';
    if (giftQty) giftQty.value = data.gift_quantity || 1;
  }

  function init(root) {
    if (root.dataset.pnReady) return;
    root.dataset.pnReady = 'true';
    root.addEventListener('change', function (event) {
      if (event.target.matches('input[name="pn_bundle"], [data-pn-variant]')) updateBundle(root);
    });
    updateBundle(root);
  }

  function boot() { document.querySelectorAll('[data-pn-bundle]').forEach(init); }
  function countdown(root) {
    if (root.dataset.pnReady) return;
    root.dataset.pnReady = 'true';
    var end = new Date(root.dataset.end || '').getTime();
    var values = { days: root.querySelector('[data-days]'), hours: root.querySelector('[data-hours]'), minutes: root.querySelector('[data-minutes]'), seconds: root.querySelector('[data-seconds]') };
    function tick() {
      if (!end || Number.isNaN(end)) return;
      var distance = Math.max(0, end - Date.now());
      var seconds = Math.floor(distance / 1000);
      var days = Math.floor(seconds / 86400); seconds %= 86400;
      var hours = Math.floor(seconds / 3600); seconds %= 3600;
      var minutes = Math.floor(seconds / 60); seconds %= 60;
      if (values.days) values.days.textContent = String(days).padStart(2, '0');
      if (values.hours) values.hours.textContent = String(hours).padStart(2, '0');
      if (values.minutes) values.minutes.textContent = String(minutes).padStart(2, '0');
      if (values.seconds) values.seconds.textContent = String(seconds).padStart(2, '0');
    }
    tick(); window.setInterval(tick, 1000);
  }
  function bootCountdowns() { document.querySelectorAll('[data-pn-countdown]').forEach(countdown); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('DOMContentLoaded', bootCountdowns);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:load', bootCountdowns);
})();
